module.exports = __webpack_public_path__ + "831c2768.png";